const LOCATION_LABELS = {
  WORK: 'Sur le travail',
  COMMUTE: 'Sur le trajet'
};

export function formatWorkAccidentListTitle(consultation, copy = {}) {
  if (!consultation?.is_work_accident) return '';

  const wa = copy.WORK_ACCIDENT || copy;
  const parts = [wa.LIST_BADGE_AT || 'Accident du travail'];

  const locationLabel =
    wa[`LOCATION_${consultation.work_accident_location}`] ||
    LOCATION_LABELS[consultation.work_accident_location];
  if (locationLabel) parts.push(locationLabel);

  if (consultation.work_accident_severity) {
    parts.push(consultation.work_accident_severity);
  }

  return parts.join(' · ');
}
